<template>
  <v-container class="contact-wrapper">
    <!-- Encabezado -->
    <div class="contact-header">
      <h2 class="contact-title">Contáct<span class="highlight">anos</span></h2>
      <p class="contact-subtitle">Completa el formulario y nos pondremos en contacto contigo</p>
      <v-divider class="divider"></v-divider>
    </div>

    <!-- Formulario y información -->
    <v-row class="contact-content">
      <v-col cols="12" md="6" class="contact-form-col">
        <v-form ref="form" @submit.prevent="submitForm" class="contact-form">
          <v-text-field
              v-model="form.name"
              label="Nombre completo"
              required
              outlined
              :rules="nameRules"
              class="form-input"
          ></v-text-field>

          <v-text-field
              v-model="form.email"
              label="Correo electrónico"
              required
              outlined
              :rules="emailRules"
              class="form-input"
          ></v-text-field>

          <v-text-field
              v-model="form.phone"
              label="Teléfono (opcional)"
              outlined
              class="form-input"
          ></v-text-field>

          <v-select
              v-model="form.service"
              :items="services"
              label="Servicio de interés"
              outlined
              class="form-input"
          ></v-select>

          <v-textarea
              v-model="form.message"
              label="Mensaje"
              required
              outlined
              :rules="messageRules"
              class="form-input"
              rows="4"
          ></v-textarea>

          <v-btn
              type="submit"
              color="primary"
              size="large"
              class="submit-btn"
              :loading="loading"
          >
            Enviar Mensaje
            <v-icon right>mdi-send</v-icon>
          </v-btn>
        </v-form>
      </v-col>

      <v-col cols="12" md="6" class="contact-info-col">
        <div class="info-card">
          <h3 class="info-title">Información de Contacto</h3>

          <div class="contact-method">
            <v-icon color="primary" large class="method-icon">mdi-email</v-icon>
            <div>
              <div class="method-label">Correo electrónico</div>
              <div class="method-value">webmaster@sheshisam.com</div>
            </div>
          </div>

          <div class="contact-method">
            <v-icon color="primary" large class="method-icon">mdi-phone</v-icon>
            <div>
              <div class="method-label">Teléfono</div>
              <div class="method-value">+1 305 784 2400</div>
              <div class="method-value">+53 52013602</div>
            </div>
          </div>

          <div class="contact-method">
            <v-icon color="primary" large class="method-icon">mdi-map-marker</v-icon>
            <div>
              <div class="method-label">Dirección</div>
              <div class="method-value">6661 SW 137 CT
                UNIT D
                MIAMI, FL 33183
              </div>
            </div>
          </div>

          <div class="social-links">
            <v-btn
                v-for="(social, index) in socialMedia"
                :key="index"
                :icon="social.icon"
                variant="text"
                size="large"
                :color="social.color"
                class="social-icon"
                :href="social.link"
                target="_blank"
            ></v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Notificaciones -->
    <v-snackbar
        v-model="showSuccess"
        color="success"
        timeout="5000"
    >
      ¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.
      <template v-slot:actions>
        <v-btn
            color="white"
            variant="text"
            @click="showSuccess = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="showError"
        color="error"
        timeout="5000"
    >
      Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.
      <template v-slot:actions>
        <v-btn
            color="white"
            variant="text"
            @click="showError = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>


export default {
  name: 'Contacto',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      services: [
        'Energía Solar',
        'Energía Eólica',
        'Consultoría Energética',
        'Almacenamiento',
        'Autoconsumo',
        'Monitorización'
      ],
      nameRules: [
        v => !!v || 'El nombre es requerido',
        v => (v && v.length >= 3) || 'El nombre debe tener al menos 3 caracteres'
      ],
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /.+@.+\..+/.test(v) || 'El email debe ser válido'
      ],
      messageRules: [
        v => !!v || 'El mensaje es requerido',
        v => (v && v.length >= 10) || 'El mensaje debe tener al menos 10 caracteres'
      ],
      socialMedia: [
        {icon: 'mdi-facebook', color: '#3b5998', link: 'https://www.facebook.com/profile.php?id=61570358939179&mibextid=rS40aB7S9Ucbxw6v'},
         //{icon: 'mdi-X', color: '#1da1f2', link: '#'},
         {icon: 'mdi-youtube', color: '#f21d36', link: 'https://youtube.com/@sheshisam?si=4u8UVYim4pDKvzv7'},
        {icon: 'mdi-instagram', color: '#e1306c', link: 'https://www.instagram.com/sheshisamcorp.services?igsh=M29ucnNoaWJzbmV3'}
      ],
      showSuccess: false,
      showError: false,


    }
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      try {
        const response = await this.$axios.post('/api/send-contact-email', {
          name: this.form.name,
          email: this.form.email,
          phone: this.form.phone,
          service: this.form.service,
          message: this.form.message
        });

        if (response.data.status === 'success') {
          this.showSuccess = true;
          this.$refs.form.reset();
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        console.error('Error:', error);
        this.showError = true;
        this.errorMessage = error.response?.data?.message || error.message;
      } finally {
        this.loading = false;
      }


    }
  }
}
</script>

<style scoped>
/* Tus estilos existentes se mantienen igual */
.contact-wrapper {
  max-width: 1400px;
  padding: 80px 24px;
  margin: 0 auto;
  background-color: #ffffff;
}

.contact-header {
  text-align: center;
  margin-bottom: 60px;
}

.contact-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0C594B;
  margin-bottom: 16px;
  line-height: 1.2;
}

.highlight {
  color: #0A9A8A;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background-color: rgba(10, 154, 138, 0.2);
  z-index: -1;
}

.contact-subtitle {
  font-size: 1.1rem;
  color: #555;
  max-width: 600px;
  margin: 0 auto 24px;
}

.divider {
  width: 100px;
  height: 3px;
  background-color: #0A9A8A;
  margin: 0 auto;
  opacity: 1;
}

/* Formulario */
.contact-form {
  padding: 24px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.form-input {
  margin-bottom: 20px;
}

.form-input >>> .v-label {
  color: #0C594B !important;
  font-weight: 500;
}

.form-input >>> .v-input__control {
  border-radius: 8px;
}

.submit-btn {
  margin-top: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Información de contacto */
.info-card {
  padding: 24px;
  height: 100%;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.info-title {
  font-size: 1.5rem;
  color: #0C594B;
  margin-bottom: 24px;
  font-weight: 600;
  text-align: center;
}

.contact-method {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.method-icon {
  margin-right: 16px;
  flex-shrink: 0;
}

.method-label {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 4px;
}

.method-value {
  font-size: 1rem;
  color: #333;
  font-weight: 500;
}

.social-links {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  gap: 12px;
}

.social-icon {
  transition: transform 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-3px);
}

/* Responsive */
@media (max-width: 960px) {
  .contact-content {
    flex-direction: column-reverse;
  }

  .contact-form-col,
  .contact-info-col {
    padding: 16px;
  }

  .info-card {
    margin-bottom: 32px;
  }
}

@media (max-width: 600px) {
  .contact-wrapper {
    padding: 40px 16px;
  }

  .contact-title {
    font-size: 1.8rem;
  }

  .contact-form,
  .info-card {
    padding: 16px;
  }
}
</style>